module.exports = __webpack_public_path__ + "static/media/page-bosy-dark.4fa1717e.png";